import { useEffect, useState } from "react";
import { Eye, BadgeCheck } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
let cache = null, inflight = null;
const load = () => inflight || (inflight = fetch(`${API}/api/views`).then((r) => r.json()).then((d) => { cache = Object.fromEntries((d.items || []).map((i) => [i.slug, i])); return cache; }).catch(() => (cache = {})));

export function useViews() {
  const [views, setViews] = useState(cache);
  useEffect(() => { if (!cache) load().then(setViews); }, []);
  return views || {};
}

export const ago = (iso, now = Date.now()) => {
  const s = Math.max(0, Math.floor((now - new Date(iso).getTime()) / 1000));
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  return d > 0 ? `${d}d ${h}h ago` : h > 0 ? `${h}h ${m}m ago` : `${m}m ago`;
};

export function SocialProof({ slug, compact = true, short = false, className = "" }) {
  const views = useViews();
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 30000); return () => clearInterval(t); }, []);
  const v = views[slug];
  // Real numbers only: page views this week (hidden below 10) and the last real approval on this destination (hidden when there is none).
  const showViews = (v?.viewing || 0) >= 10, showApproved = Boolean(v?.last_approved_at);
  if (!v || (!showViews && !showApproved)) return null;
  return (
    <p className={`flex flex-wrap items-center gap-x-3 gap-y-0.5 ${compact ? "text-xs" : "text-sm"} text-label2 ${className}`} data-testid={`social-proof-${slug}`}>
      {showViews && <span className="inline-flex items-center gap-1"><Eye className={compact ? "h-3 w-3" : "h-3.5 w-3.5"} /> <span className="font-semibold text-foreground" data-testid={`social-viewing-${slug}`}>{v.viewing.toLocaleString()}</span> {short ? "views" : "page views this week"}</span>}
      {showApproved && <span className="inline-flex items-center gap-1 text-success-strong"><BadgeCheck className={compact ? "h-3 w-3" : "h-3.5 w-3.5"} /> Approved <span data-testid={`social-approved-${slug}`}>{short ? ago(v.last_approved_at, now).replace(/^(\d+[dh]) \d+[hm] ago$/, "$1 ago") : ago(v.last_approved_at, now)}</span></span>}
    </p>
  );
}
